import { Button, ButtonGroup } from '@mui/material';
import { ConversationDraftSendOptionSection } from '@provision/conversation-types';
import { type MouseEvent, MutableRefObject, type ReactElement, useCallback } from 'react';
import { DynamicIcon } from 'src/components';
import { SendButton } from 'src/components/RichTextEditor/buttons';

export interface SendOptionItem {
  id: string;
  label: string;
  section: ConversationDraftSendOptionSection;
  description?: string;
  icon?: string;
}

interface SendOptionsButtonProps {
  buttonText?: string;
  disabled?: boolean;
  isLoading?: boolean;
  onSend: () => void;
  buttonRef: MutableRefObject<HTMLButtonElement | null>;
  startIcon?: string;
  onOpenOptions: () => void;
}

export const SendOptionsButton = ({
  buttonText = 'Send',
  disabled,
  isLoading,
  onSend,
  buttonRef,
  startIcon,
  onOpenOptions,
}: SendOptionsButtonProps): ReactElement => {
  const handleToggle = useCallback(
    (event: MouseEvent<HTMLButtonElement>): void => {
      event.preventDefault();
      onOpenOptions();
    },
    [onOpenOptions],
  );

  return (
    <ButtonGroup variant="contained" sx={{ flexShrink: 0, boxShadow: 'none' }}>
      <SendButton
        ref={buttonRef}
        type="submit"
        buttonText={buttonText}
        isLoading={isLoading}
        onClick={onSend}
        disabled={disabled || isLoading}
        startIcon={startIcon}
      />
      <Button
        type="button"
        variant="contained"
        color="primary"
        disabled={disabled || isLoading}
        onClick={handleToggle}
        sx={{ minWidth: 0, px: 1 }}
        aria-haspopup="listbox"
        aria-label="Open Smart Send"
        aria-expanded="false"
        aria-controls="send-options-autocomplete"
      >
        <DynamicIcon name="arrow_drop_down" />
      </Button>
    </ButtonGroup>
  );
};

export default SendOptionsButton;
